const { defineMessages } = require('@sm/intl');

const TYPE_TEXT = '[Type: Text][Vis: high] - Feature Set Cell Value Item';

export default defineMessages({
  base_response_count: {
    id: 'PricingDetails.FeatureCell.BaseResponseCount',
    defaultMessage: '{amount} responses per year**',
    desc: TYPE_TEXT,
  },
  num_free_responses: {
    id: 'PricingDetails.FeatureCell.NumFreeResponses',
    defaultMessage: '{amount} responses per month**',
    desc: TYPE_TEXT,
  },
  create_question_limit: {
    id: 'PricingDetails.FeatureCell.CreateQuestionLimit',
    defaultMessage: '{amount} questions per survey',
    desc: TYPE_TEXT,
  },
  collector_create_limit: {
    id: 'PricingDetails.FeatureCell.CollectorCreateLimit',
    defaultMessage: 'Use {amount} collectors per survey',
    desc: TYPE_TEXT,
  },
  CONTACT_US: {
    id: 'PricingDetails.FeatureCell.BaseResponseCount',
    defaultMessage: 'Contact Us',
    desc: TYPE_TEXT,
  },
  BASIC_COMPARE_FILTER: {
    id: 'PricingDetails.FeatureCell.BasicCompareFilter',
    defaultMessage: '1 filter',
    desc: TYPE_TEXT,
  },
  BASIC_NUM_RESPONSES: {
    id: 'PricingDetails.FeatureCell.BasicNumberOfResponses',
    defaultMessage: 'View {amount} responses per survey',
    desc: TYPE_TEXT,
  },
  MANUAL: {
    id: 'PricingDetails.FeatureCell.Manual',
    defaultMessage: 'Manual',
    desc: TYPE_TEXT,
  },
  MANUAL_RULE: {
    id: 'PricingDetails.FeatureCell.ManualRule',
    defaultMessage: 'Manual and Rule-based',
    desc: TYPE_TEXT,
  },
  TEMPLATE_ENABLED_VALUE: {
    id: 'PricingDetails.FeatureCell.TemplateEnabledValue',
    defaultMessage: '180 +',
    desc: TYPE_TEXT,
  },
  BASIC_TEMPLATE_ENABLED_VALUE: {
    id: 'PricingDetails.FeatureCell.BasicTemplateEnabledValue',
    defaultMessage: '40 short survey templates',
    desc: TYPE_TEXT,
  },
});
